import React from 'react'

import '../styles/Home.css'

/* img */
import LearnImg from '../img/brainstorm.png'
import GamesImg from '../img/game-control.png'
import DicImg from '../img/book.png'
import FavImg from '../img/like.png'

import { Link } from 'react-router-dom'
export default function Home() {
  return (
    <div className='Home'>
      <main className='Home-hero'>
        <div className="Home-hero-container">
          <div className='Home-hero-container-bigTxt'>
            <h1>Learn Practice Explore</h1>
            <p>all in one place.</p>
          </div>
          <div className='Home-hero-container-links'>
              <Link className="feature" to='/learn'>
                <img src={LearnImg} alt="" />
                <h3>Learn</h3>
                {/* <p>Learn new Words</p> */}
              </Link>
              <Link className="feature" to='/games'>
                <img src={GamesImg} alt="" />
                <h3>Games</h3>
                {/* <p>Fun games to play</p> */}
              </Link>
              <Link className="feature" to='/dictionary'>
                <img src={DicImg} alt="" />
                <h3>Dictionary</h3>
                {/* <p>Search any word</p> */}
              </Link>
              <Link className="feature" to='/favourites'>
                <img src={FavImg} alt=""  />
                <h3>Favourites</h3>
                {/* <p>List of your favourite words</p> */}
              </Link>
          </div>
        </div>
      </main>
   
      <section className='About'>
        <h2>About</h2>
        <p> 
          Are you preparing for a English Proficiency Test? Or just want to improve your vocabulary? Use <span className='brand'>Vocabo</span> to turn a boring and tedious task of learning new words into a  fun , exciting and challenging process.
        </p>
      </section>

 


    </div>
  )
}
